import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '@/SEO';
import VedaStamp from '@/components/VedaStamp';

const POORVAM_RITUALS = [
  {
    title_ta: 'பும்ஸுவநம் (Pumsavanam)',
    subtitle: 'கர்ப்பத்தின் 3-வது மாதத்தில் பிறக்கப்போகும் மகப்பேறு வம்சவிருத்தி சுப சடங்கு',
    veda: 'sama',
    vedaName: 'சாந்தோக்ய ஸாம வேதம்',
    url: '/vaideekam/pumsavanam',
    desc: 'ஸ்மார்த்த சாந்தோக்ய ஸாமவேத பிரயோகம் (smartha_prayogam_devanagari_text.txt விதிகளின்படி)'
  },
  {
    title_ta: 'ப்ரதிஸரம் / ரக்ஷா பந்தனம் (Prathisaram)',
    subtitle: 'மங்கள கர்மாங்க காப்புக்கட்டு ப்ரதிசர பந்தன மந்த்ரங்கள்',
    veda: 'sama',
    vedaName: 'சாந்தோக்ய ஸாமவேதம்',
    url: '/vaideekam/ankuram',
    desc: 'ஸாமவேத சாந்தோக்ய பூர்வப்ரயோக ரக்ஷாபந்தனம்'
  },
  {
    title_ta: 'ஸீமந்தம் (Seemantham)',
    subtitle: 'கர்ப்பிணி பெண்ணிற்கான 7-ஆம் மாத மங்கள சடங்கு & மந்த்ரங்கள்',
    veda: 'yajur',
    vedaName: 'ஆபஸ்தம்ப யஜுர் வேதம்',
    url: '/vaideekam/seemantham',
    desc: 'ஆபஸ்தம்ப யஜுர் பூர்வப்ரயோகம் (apastamba_217_pages_extracted.txt விதிகளின்படி)'
  },
  {
    title_ta: 'விவாஹம் (Vivaaham - திருமணம்)',
    subtitle: 'வைதீக திருமணச் சடங்குகள், மாங்கல்ய தாரணம் & சப்தபதி',
    veda: 'yajur',
    vedaName: 'ஆபஸ்தம்ப யஜுர் வேதம்',
    url: '/vaideekam/vivaaham',
    desc: 'ஆபஸ்தம்ப யஜுர் வேத விவாஹ பூர்வப்ரயோகம்'
  },
  {
    title_ta: 'உபநயனம் (Upanayanam - பூணூல்)',
    subtitle: 'பிரம்மோபதேசம், பூணூல் தரித்தல் & காயத்ரி மந்திர உபதேசம்',
    veda: 'yajur',
    vedaName: 'ஆபஸ்தம்ப யஜுர் வேதம்',
    url: '/vaideekam/upanayanam',
    desc: 'ஆபஸ்தம்ப யஜுர் பூர்வப்ரயோக உபநயன க்ரமம்'
  },
  {
    title_ta: 'க்ருஹப்ரவேசம் (Grihapravesam)',
    subtitle: 'புதிய இல்லப் பிரவேசம், கணபதி ஹோமம் & புண்யாஹவாசனம்',
    veda: 'yajur',
    vedaName: 'ஆபஸ்தம்ப யஜுர் வேதம்',
    url: '/vaideekam/grihapravesam',
    desc: 'ஆபஸ்தம்ப யஜுர் வேத கிருஹப்பிரவேசம்'
  },
  {
    title_ta: 'அக்ஷராப்யாசம் (Aksharaabhyaasam)',
    subtitle: 'குழந்தைக்கு முதன்முதலில் கல்வி மற்றும் எழுத்து பயிற்சி தொடக்கம்',
    veda: 'yajur',
    vedaName: 'ஆபஸ்தம்ப யஜுர் வேதம்',
    url: '/vaideekam/aksharaabhyaasam',
    desc: 'ஆபஸ்தம்ப யஜுர் பூர்வப்ரயோக வித்யாரம்பம்'
  },
  {
    title_ta: 'அன்னப்ராசனம் (Annapraasanam)',
    subtitle: 'குழந்தைக்கு 6-வது மாதத்தில் முதன்முதலில் அன்னம் ஊட்டுதல்',
    veda: 'yajur',
    vedaName: 'ஆபஸ்தம்ப யஜுர் வேதம்',
    url: '/vaideekam/annapraasanam',
    desc: 'ஆபஸ்தம்ப யஜுர் பூர்வப்ரயோகம்'
  },
  {
    title_ta: 'உதகசாந்தி (Udakasaandhi)',
    subtitle: 'மங்கள கார்யங்களுக்கு முன் நீர் கலச ஸ்தாபன வேத பாராயணம்',
    veda: 'yajur',
    vedaName: 'ஆபஸ்தம்ப யஜுர் வேதம்',
    url: '/vaideekam/udakasaandhi',
    desc: 'ஆபஸ்தம்ப யஜுர் வேத உதகசாந்தி ஜபம்'
  },
  {
    title_ta: 'அஷ்டவ்ரதம் (Ashtavradham)',
    subtitle: 'உபநயனத்திற்குப் பின் பிரம்மச்சாரி அனுஷ்டிக்கும் வேத விரதங்கள்',
    veda: 'yajur',
    vedaName: 'ஆபஸ்தம்ப யஜுர் வேதம்',
    url: '/vaideekam/ashtavradham',
    desc: 'ஆபஸ்தம்ப யஜுர் வேத விரதங்கள்'
  },
  {
    title: 'நாமகரணம் (Naamakaranam)',
    subtitle: 'குழந்தைக்கு 11-வது நாளில் நாமகரணம் (பெயர் சூட்டுதல்) சடங்கு',
    veda: 'yajur',
    vedaName: 'ஆபஸ்தம்ப யஜுர் வேதம்',
    url: '/vaideekam/naamakaranam',
    desc: 'ஆபஸ்தம்ப யஜுர் பூர்வப்ரயோகம்'
  },
  {
    title_ta: 'ஜாதகர்மா (Jaadhakarma)',
    subtitle: 'குழந்தை பிறந்தவுடன் தந்தையால் செய்ய வேண்டிய ஆயுஷ்ய அபிவிருத்தி சடங்கு',
    veda: 'yajur',
    vedaName: 'ஆபஸ்தம்ப யஜுர் வேதம்',
    url: '/vaideekam/jaadhakarma',
    desc: 'ஆபஸ்தம்ப யஜுர் பூர்வப்ரயோகம்'
  },
  {
    title_ta: 'ஔபாஸனம் (Aupaasanam)',
    subtitle: 'கிருஹஸ்தன் தினசரி செய்யும் நித்ய ஔபாஸனா அக்னி கார்யம்',
    veda: 'yajur',
    vedaName: 'ஆபஸ்தம்ப யஜுர் வேதம்',
    url: '/vaideekam/aupaasanam',
    desc: 'ஆபஸ்தம்ப யஜுர் வேத ஔபாஸனம்'
  }
];

const PoorvamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-5xl mx-auto p-4 md:p-6 pb-24 bg-[#FAF6EE] font-sans">
      <SEO 
        title="பூர்வம் - சுபகார்யங்கள் & வேத வகைப்பாடு - Ahobilam" 
        description="ஆபஸ்தம்ப யஜுர் வேதம் மற்றும் சாந்தோக்ய ஸாம வேத பூர்வ சுபகார்ய பிரயோகங்கள், சீமந்தம், விவாஹம், உபநயனம், பும்ஸுவநம்." 
      />
      
      {/* Header Banner */}
      <div className="header-card bg-gradient-to-r from-[#1A237E] via-[#283593] to-[#1A237E] text-amber-100 p-6 md:p-8 rounded-2xl shadow-md border-b-4 border-[#D4AF37] mb-8">
        <div className="flex items-center justify-between flex-wrap gap-3 mb-4 border-b border-amber-300/30 pb-4">
          <div>
            <span className="text-xs font-semibold uppercase tracking-wider text-amber-300 block mb-1">
              ஆஹ்நிக & பூர்வ காண்டம்
            </span>
            <h1 className="text-2xl md:text-4xl font-bold text-amber-200 tracking-wide">
              பூர்வம் - சுபகார்யங்கள் & வேத வகைப்பாடு
            </h1>
          </div>
        </div>

        {/* Dual Veda Stamps Header Box */}
        <div className="bg-white/10 p-4 rounded-xl border border-amber-300/40 backdrop-blur-xs">
          <p className="text-xs font-bold uppercase tracking-wider text-amber-300 mb-2">
            📌 வேத கிளை & சூத்திர தெளிவுரை (Veda Classification Guide):
          </p>
          <div className="flex items-center flex-wrap gap-3">
            <VedaStamp veda="yajur" />
            <VedaStamp veda="sama" />
          </div>
          <p className="text-xs text-amber-100/80 mt-2 font-medium">
            * ஸ்மார்த்த தேவநாகரி பிரயோகங்கள் (பும்ஸுவநம், ப்ரதிஸரம்) <strong>ஸாம வேதத்தை</strong> சார்ந்தவை. ஆபஸ்தம்ப 217 பக்க நூலின் பிரயோகங்கள் <strong>ஆபஸ்தம்ப யஜுர் வேதத்தை</strong> சார்ந்தவை.
          </p>
        </div>
      </div>

      {/* Intro Description */}
      <div className="bg-white p-6 rounded-2xl border border-amber-200 shadow-sm mb-8 space-y-3">
        <h2 className="text-lg font-bold text-[#1A237E] flex items-center space-x-2">
          <span>🪔</span>
          <span>பூர்வ சுபகார்யங்கள் முன்னுரை</span>
        </h2>
        <p className="text-sm md:text-base text-gray-800 leading-relaxed">
          இது ஒரு விரிவான வைதீக பூர்வ ப்ரயோகங்கள் பகுதி. வைதீக விஷயங்களின் முக்கியத்துவத்தை அறிந்து கொள்பவர்களுக்காக மட்டுமன்றி, வெளிநாடுகளிலும் வாத்தியார்கள் கிடைக்காத பகுதியில் தாங்களாகவே எல்லாவிதமான வைதீக காரியங்களையும் சாஸ்திர முறைப்படி நடத்திக் கொள்ள இந்த பகுதி உதவுகிறது.
        </p>
      </div>

      {/* Grid of All Poorvam Rituals with Explicit Veda Stamps */}
      <div className="space-y-4">
        <h2 className="text-xl font-bold text-[#1A237E] flex items-center space-x-2 border-b-2 border-amber-300 pb-2">
          <span>📜</span>
          <span>பூர்வம் - சுபகார்ய பிரயோகங்கள் பட்டியல் (Veda Classified Rituals)</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {POORVAM_RITUALS.map((item, idx) => (
            <Link
              key={idx}
              to={item.url}
              className="bg-white hover:bg-amber-50/80 p-5 rounded-2xl border-2 border-amber-200 hover:border-[#CC6600] transition-all shadow-xs hover:shadow-md flex flex-col justify-between group"
            >
              <div>
                <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
                  <VedaStamp veda={item.veda} />
                  <span className="text-xs font-bold text-[#1A237E] group-hover:underline">விவரம் ➔</span>
                </div>

                <h3 className="text-lg font-bold text-[#1A237E] group-hover:text-[#CC6600] transition-colors mb-1">
                  {item.title_ta}
                </h3>
                <p className="text-xs md:text-sm text-gray-700 font-medium mb-2">
                  {item.subtitle}
                </p>
              </div>

              <div className="text-[11px] text-[#CC6600] font-semibold pt-2 border-t border-amber-100">
                {item.desc}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PoorvamPage;
